var map = {
	"./en-ng.json": [
		"0YbV",
		2
	],
	"./en.json": [
		"Om/e",
		1
	],
	"./fr.json": [
		"rqa7",
		3
	],
	"./it.json": [
		"G87Z",
		4
	],
	"./pl.json": [
		"cxYL",
		5
	],
	"./pt-br.json": [
		"o37p",
		6
	],
	"./sp.json": [
		"9GkN",
		7
	],
	"./spark/en.json": [
		"h5vG",
		8
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "mZkB";
module.exports = webpackAsyncContext;